module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C52"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C53"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Acknowledgments#page_vii"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C54"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#page_1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C54"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_1__The_Political_Theology_of_Lat#page_11"
    }
  }, [_vm._v("1. The Political Theology of Late Capital")])]), _vm._v(" "), _c('p', {
    staticClass: "C54"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_2__The_Political_and_the_Economi#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Political and the Economic")])]), _vm._v(" "), _c('p', {
    staticClass: "C54"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_3__Neoliberalism_s_Demons#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Neoliberalism’s Demons")])]), _vm._v(" "), _c('p', {
    staticClass: "C54"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_4__This_Present_Darkness#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. This Present Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "C53"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Conclusion__After_Neoliberalism#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: After Neoliberalism")])]), _vm._v(" "), _c('p', {
    staticClass: "C54"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Notes#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C54"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Bibliography#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "C54"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Index#page_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e1eaf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Contents.vue
// module id = 66
// module chunks = 0